export { MenuCodeEnum } from '/@/enums/menuCodeEnum';

export enum RoleEnum {
  // 正式会员
  FORMAL = 'FORMAL',

  // 普通会员
  ORDINARY = 'ORDINARY',
}

// 账号类型
export enum AccountTypeEnum {
  // 管理员
  ADMIN = 0,
  // 普通账号
  ORDINARY = 1,
}
